module.exports = {"common":{"BREADCRUMB_ROOT":"Carte cadeau"}}


//////////////////
// WEBPACK FOOTER
// ./src/services/i18n/json/127.json
// module id = 1058
// module chunks = 0